import { Loan } from '@nemuru-eng/js-api-client';
import { Insurance, InsuranceType } from '@nemuru-eng/js-api-client/slim';

export type LoanInsuranceDisplay = Pick<Insurance, 'type'> & Partial<Insurance>;

const isDisplayableInsuranceType = (type: InsuranceType | null | undefined): type is InsuranceType => {
  return Boolean(type) && type !== InsuranceType.NO;
};

export const LoanInsuranceMap = {
  fromLoan: (loan: Loan): LoanInsuranceDisplay | null => {
    const pricingInsurance = loan.pricingInsurance as Insurance | null | undefined;

    if (isDisplayableInsuranceType(pricingInsurance?.type)) {
      return pricingInsurance;
    }

    const insuranceType = loan.loanConditions.loanCalculator.insurance?.value;

    if (!isDisplayableInsuranceType(insuranceType)) {
      return null;
    }

    return { type: insuranceType };
  },

  hasPricingDetails: (insurance: LoanInsuranceDisplay | null | undefined): insurance is Insurance => {
    return Boolean(insurance?.provider && insurance.cost);
  },
};
